import { Autocomplete, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import swal from 'sweetalert';

import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt';
import SaveIcon from '@mui/icons-material/Save';
import Divider from '@mui/material/Divider';
import { Box } from '@mui/system';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Controller, useForm } from 'react-hook-form';
import { fetchEvaluacionCrearPeriodo, fetchEvaluacionEditarPeriodo } from '../../../redux/Evaluaciones/EvaluacionesSlice';

export const AgregarEditarPeriodoEvaluacionModal = ({ open, setOpen, periodo, tipoDeAccion, ultimaEvaluacionAno }) => {
  const {
    formState: { errors },
    control,
    watch,
    setValue,
    handleSubmit,
  } = useForm({
    defaultValues: {
      iniciodePeriodo: new Date(),
      fechaTermino: new Date(),
    },
  });

  // * DESESTRUCTURACION DEL OBJETO DEL PERIODO.
  const { iniciodePeriodo, anio, fechaTermino } = periodo;

  // ? HOOK-DISPATCH
  const dispatch = useDispatch();

  // * ENVIANDO DATA A LA API.
  const sendDataApiEvaluaciones = () => {
    if (tipoDeAccion === 1) {
      const data = {
        anio: ultimaEvaluacionAno + 1,
        estado: 0,
        iniciodePeriodo: watch('iniciodePeriodo'),
        fechaTermino: watch('fechaTermino'),
      };

      // * MENSAJE DE CONFIRMACION
      swal({
        title: 'Advertencia',
        text: `Estás seguro/a que desea crear el periodo ${ultimaEvaluacionAno + 1}?`,
        icon: 'warning',
        buttons: ['No', 'Si'],
      }).then((respuesta) => {
        if (respuesta) {
          dispatch(fetchEvaluacionCrearPeriodo(data));
        }
      });
    } else if (tipoDeAccion === 2) {
      const data = {
        anio: anio,
        estado: 0,
        iniciodePeriodo: watch('iniciodePeriodo'),
        fechaTermino: watch('fechaTermino'),
      };

      dispatch(fetchEvaluacionEditarPeriodo(data));
    }
  };

  // * FUNCION USADA EN EL BOTON CANCELAR.
  const cancelAction = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (tipoDeAccion === 1) {
      setValue('iniciodePeriodo', obtenerFecha());
      setValue('fechaTermino', obtenerFecha());
    } else if (tipoDeAccion === 2) {
      setValue('iniciodePeriodo', iniciodePeriodo);
      setValue('fechaTermino', fechaTermino);
    }
  }, [periodo, tipoDeAccion]);

  // * FUNCION PARA OBTENER LA FECHA DEL PROXIMO PERIODO DE EVALUACION A CREAR.
  const obtenerFecha = () => {
    const fecha = new Date();
    fecha.setFullYear(ultimaEvaluacionAno + 1);
    return fecha; // Devuelve un objeto Date
  };

  return (
    <Dialog PaperProps={{ sx: { width: '40%', height: '40%' } }} open={open} maxWidth="lg">
      <DialogTitle sx={{ textTransform: 'uppercase' }} className="text-mem text-center">
        {tipoDeAccion === 1 ? 'Agregar' : 'Editar'} Período
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Typography>Período</Typography>
        <Autocomplete
          disabled
          className="mb-3"
          disablePortal
          disableClearable
          options={tipoDeAccion === 1 ? ultimaEvaluacionAno + 1 : periodo}
          value={tipoDeAccion === 1 ? ultimaEvaluacionAno + 1 : anio}
          noOptionsText={'No encontrado'}
          renderOption={(props, periodo) => (
            <Box
              component="option"
              {...props}
              key={tipoDeAccion === 1 ? ultimaEvaluacionAno + 1 : periodo.anio}
              value={tipoDeAccion === 1 ? ultimaEvaluacionAno + 1 : periodo.anio}
            >
              {tipoDeAccion === 1 ? ultimaEvaluacionAno + 1 : periodo.anio}
            </Box>
          )}
          renderInput={(params) => <TextField {...params} label={' '} />}
          on
        />

        <form onSubmit={handleSubmit(sendDataApiEvaluaciones)}>
          <div className="form-group">
            <Typography>Fecha de Inicio</Typography>
            <Controller
              control={control}
              className="mb-3"
              name="iniciodePeriodo"
              render={({ field }) => (
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    inputFormat="dd/MM/yyyy"
                    label={' '}
                    mask="__/__/____"
                    value={field.value}
                    onChange={field.onChange}
                    renderInput={(params) => <TextField height={10} className="form-control" style={{ height: 10 }} {...params} />}
                  />
                </LocalizationProvider>
              )}
            />
            <p className="text-danger mt-3">{errors.fechaInicio?.message}</p>
            <p className="text-danger">{errors.fechaInicio?.message}</p>
          </div>

          <div className="form-group">
            <Typography sx={{ mt: 4 }}>Fecha de Término</Typography>
            <Controller
              control={control}
              className="mb-3"
              name="fechaTermino"
              render={({ field }) => (
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    inputFormat="dd/MM/yyyy"
                    minDate={watch('iniciodePeriodo')}
                    label={' '}
                    mask="__/__/____"
                    value={field.value}
                    onChange={field.onChange}
                    renderInput={(params) => <TextField height={10} className="form-control" style={{ height: 10 }} {...params} />}
                  />
                </LocalizationProvider>
              )}
            />
            <p className="text-danger mt-3">{errors.fechaTermino?.message}</p>
            <p className="text-danger">{errors.fechaTermino?.message}</p>
          </div>
        </form>
      </DialogContent>

      <DialogActions className="justify-content-center">
        <button onClick={() => cancelAction()} className="btn btn-danger">
          <DoNotDisturbAltIcon sx={{ marginTop: -0.5, marginRight: 0.5 }} />
          CANCELAR
        </button>
        <button className="btn btn-primary-mem" onClick={() => sendDataApiEvaluaciones()}>
          <SaveIcon sx={{ marginTop: -0.5, marginRight: 0.5 }} />
          GUARDAR
        </button>
      </DialogActions>
    </Dialog>
  );
};
